import { faChevronDown, faPlus, faUpload } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Authentication from "@yodlee/common-components/dist/types/interfaces/authentication";
import { NotificationUtils } from "@yodlee/common-components/dist/utilities";
import { CreateBulkSubscriptionContainer, CreateSubscriptionContainer } from "@yodlee/ycc-notification-widget/dist/containers";
import { Drawer, Dropdown, Icon, Menu } from "antd";
import React, { useContext, useRef, useState } from "react";
import { ApplicationContext } from "../context";
import { getAuthenticationDetails } from "../utilities/authentication";

type INotfAddUserOptionsProps = {
    onAddSubscriber: () => void
}

const NotfAddUserOptions: React.FC<INotfAddUserOptionsProps> = ({ onAddSubscriber }) => {
    const [addUserType, setAddUserType] = useState<"single" | "bulk">("single");
    const [addUserModalVisible, setAddUserModalVisible] = useState<boolean>(false);
    const [bulkUsersModalvisible, setBulkUsersModalVisible] = useState<boolean>(false);
    const { selectedBrand, onload } = useContext(ApplicationContext);
    const updateOnCloseBulkCreate: any = useRef();
    const authenticationDetails: Authentication = { ...getAuthenticationDetails(selectedBrand), metaData: { yc4ApiUrl: onload?.yc4ApiUrl } }

    const addUserModal =
        <Drawer
            width="85vw"
            placement="right"
            destroyOnClose={true}
            onClose={() => setAddUserModalVisible(false)}
            visible={addUserModalVisible}
            zIndex={addUserModalVisible ? 1001 : 1000}
        >
            <div className="margin-top-md">
                <CreateSubscriptionContainer
                    onCancel={() => setAddUserModalVisible(false)}
                    onCreate={(userResp) => {
                        let usersFailed = false, usersCreated = false;
                        (userResp || []).forEach((userRespItem) => {
                            if (userRespItem?.creationStatus === "SUCCESS") {
                                NotificationUtils.success("Success.", <div>
                                    <b>{userRespItem?.creationEnv}</b> subscriber creation successful.
                                </div>, "primary", undefined, undefined, 4);
                                usersCreated = true;
                            } else {
                                NotificationUtils.error("Error.", <div>
                                    <b>{userRespItem?.creationEnv}</b> subscriber creation failed.
                                    {userRespItem?.response?.data?.message}
                                </div>, "primary", undefined, undefined, 4);
                                usersFailed = true;
                            }
                        })

                        if (usersCreated)
                            onAddSubscriber();

                        if (!usersFailed)
                            setAddUserModalVisible(false);
                    }}
                    authentication={authenticationDetails}
                />
            </div>
        </Drawer>

    const bulkUploadModal = <CreateBulkSubscriptionContainer
        authentication={authenticationDetails}
        visible={bulkUsersModalvisible}
        onCancel={() => { setBulkUsersModalVisible(false); if (updateOnCloseBulkCreate.current) { updateOnCloseBulkCreate.current = false; onAddSubscriber(); } }}
        onCreate={(data) => {
            let allUsersSuccessful = true;
            (data?.data || []).forEach((result: any) => {
                if (result?.status !== "SUCCESS")
                    allUsersSuccessful = false;
            })
            if (allUsersSuccessful) {
                NotificationUtils.success("Success", "Subscribers created successfully.");
                setBulkUsersModalVisible(false);
                onAddSubscriber();
                if (updateOnCloseBulkCreate.current)
                    updateOnCloseBulkCreate.current = false;
            } else
                updateOnCloseBulkCreate.current = true;
        }}
    />

    return <>
        <Dropdown.Button
            htmlType="submit"
            onClick={() => {
                if (addUserType === "single") {
                    setAddUserModalVisible(!addUserModalVisible)
                } else {
                    setBulkUsersModalVisible(!bulkUsersModalvisible)
                }
            }}
            overlay={
                <Menu
                    className="checked-menu"
                    selectable={true}
                    defaultSelectedKeys={[addUserType]}
                    onSelect={(e: any) => setAddUserType(e.key)}
                >
                    <Menu.Item key="single"
                        onClick={() => {
                            setAddUserModalVisible(!addUserModalVisible)
                        }}>
                        {`Add subscriber`}
                    </Menu.Item>
                    <Menu.Item key="bulk"
                        onClick={() => {
                            setBulkUsersModalVisible(!bulkUsersModalvisible)
                        }}>
                        {`Bulk upload`}
                    </Menu.Item>
                </Menu>
            }
            icon={<Icon component={() => <FontAwesomeIcon icon={faChevronDown} />} />}
        >
            {
                addUserType === "single" ?
                    <React.Fragment>
                        <Icon className="font-size-lg" component={() => <FontAwesomeIcon icon={faPlus} />} /><span className="margin-left-xs" />{`Add subscriber`}
                    </React.Fragment> :
                    <React.Fragment>
                        <Icon className="font-size-lg" component={() => <FontAwesomeIcon icon={faUpload} />} /><span className="margin-left-xs" />{`Bulk upload`}
                    </React.Fragment>
            }
        </Dropdown.Button>
        {addUserModal}
        {bulkUploadModal}
    </>
}

export default NotfAddUserOptions;